var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/add-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.16663 9.9974C2.16663 5.68187 5.68443 2.16406 9.99996 2.16406C14.3155 2.16406 17.8333 5.68187 17.8333 9.9974C17.8333 14.3129 14.3155 17.8307 9.99996 17.8307C5.68443 17.8307 2.16663 14.3129 2.16663 9.9974ZM11.125 13.3307V11.1224H13.3333C13.9511 11.1224 14.4583 10.6152 14.4583 9.9974C14.4583 9.37959 13.9511 8.8724 13.3333 8.8724H11.125V6.66406C11.125 6.04625 10.6178 5.53906 9.99996 5.53906C9.38215 5.53906 8.87496 6.04625 8.87496 6.66406V8.8724H6.66663C6.04882 8.8724 5.54163 9.37959 5.54163 9.9974C5.54163 10.6152 6.04882 11.1224 6.66663 11.1224H8.87496V13.3307C8.87496 13.9485 9.38215 14.4557 9.99996 14.4557C10.6178 14.4557 11.125 13.9485 11.125 13.3307Z",
    fill: "#A461D8",
    stroke: "#A461D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.dda77d3823cf9367f23dcb9f18e73b8b.svg";
export { ForwardRef as ReactComponent };